import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuItem, Button } from '@mui/material';
import { ArrowDropDown as ArrowDownIcon } from '@mui/icons-material';

import { useAuth, AuthCompanyContext } from '@homesusa/auth';
import { MarketCode, MarketCodeLabel, Company, RoleUser } from '@homesusa/core';
import { MenuStyled } from './header-user.style';
import { AnchorEl } from './use-anchor-el';

const menuId = 'market-menu-appbar';
export function MarketButton({ anchor }: { anchor: AnchorEl }): JSX.Element {
  const { currentMarket } = React.useContext(AuthCompanyContext);

  return (
    <Button aria-controls={menuId} onClick={anchor.handleClick} endIcon={<ArrowDownIcon />}>
      {MarketCodeLabel.get(currentMarket)}
    </Button>
  );
}

export function MarketButtonMenu({
  markets,
  anchor
}: {
  markets: Record<string, Company[]>;
  anchor: AnchorEl;
}): JSX.Element {
  const { setCurrentCompany } = React.useContext(AuthCompanyContext);
  const { user: userProfile } = useAuth();
  const navigate = useNavigate();

  return (
    <MenuStyled
      anchorEl={anchor.anchorEl}
      open={anchor.open}
      onClose={anchor.handleClose}
      keepMounted
      id={menuId}
    >
      {Object.keys(markets)
        .slice()
        .sort()
        .map((marketCode) => (
          <MenuItem
            key={marketCode}
            value={marketCode}
            onClick={(): void => {
              const firstCompany =
                userProfile?.role != RoleUser.User ? null : markets[marketCode]?.[0];
              setCurrentCompany(firstCompany, marketCode as MarketCode)
                .then(() => anchor.handleClose())
                .finally(() => navigate('/'));
            }}
          >
            {MarketCodeLabel.get(marketCode as MarketCode)}
          </MenuItem>
        ))}
    </MenuStyled>
  );
}
